import { render, staticRenderFns } from "./RoutesDifficultyDropdown.vue?vue&type=template&id=4f4e3247&"
import script from "./RoutesDifficultyDropdown.vue?vue&type=script&lang=ts&"
export * from "./RoutesDifficultyDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports